document.querySelectorAll('facet-filters-form input').forEach(function(val) {
    val.addEventListener('change', function() {
      setTimeout(function() {
        window.location.reload();
      }, 500);
    });
});

window.addEventListener('load', function() {
  var elementExists = document.querySelector('h2.jdgm-rev-widg__title');
  if( elementExists ){
    elementExists.innerHTML = 'What People Are Saying';
  }
  
});


// Custom FAQ Accordion
var $lastSelected;
jQuery('.faqpage .accordion').on('click', function() {
    jQuery('.faqpage .accordion').next('.container').slideUp();
    jQuery('.faqpage .accordion').removeClass('accordion-toggled');

// console.log((this) == $lastSelected, this, $lastSelected);
    
        if (! ((this) == $lastSelected)) {    jQuery(this).next('.container').slideToggle();
        jQuery(this).toggleClass('accordion-toggled');
    $lastSelected = this;
      } else 
             $lastSelected = null;
    
});

// Get all elements with the class "article-card__author"
const authorElements = document.getElementsByClassName("article-card__author");

// Iterate over the author elements and update only "Mohana Growmodo"
for (let i = 0; i < authorElements.length; i++) {
  const authorElement = authorElements[i];
  if (authorElement.textContent.includes("Mohana Growmodo")) {
    authorElement.textContent = authorElement.textContent.replace("Mohana Growmodo", "Nathan Mah");
  }
}
